import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledComponent } from '../types';
import { Logo } from './Logo';
import { Section } from './Section';
import { rgba } from './utils/rgba';

export const Header: StyledComponent = styled.header`
  position: relative;
  z-index: 1000;
  background-color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};

  a {
    outline: none !important;
  }

  ${Logo} {
    height: 71px;
  }
`;

interface HeaderMobileProps {
  closed?: boolean;
}

type HeaderMobilePropsThemed = ThemeProps<Theme> & HeaderMobileProps;

export const HeaderMobile: StyledComponent<HeaderMobileProps> = styled.header`
  height: 60px;
  /* position: fixed; */
  width: 100%;
  top: 0;
  background: ${(props: HeaderMobilePropsThemed) => props.theme.colors.white};
  z-index: 300;

  ${(props: HeaderMobilePropsThemed) =>
    props.closed &&
    css`
      box-shadow: 3px 3px 5px 0px ${rgba(props.theme.colors.black, 0.2)};
    `}

  ${Section} {
    height: 100%;
  }

  ${Logo} {
    height: 22px;
    position: absolute;
    top: 19px;
    margin: 0;

    canvas,
    svg {
      height: 22px;
      width: 127px;
    }

    text,
    .text {
      display: none;
    }
  }
`;
